import * as  React from "react";

export function GetInTouch() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
      <g>
        <path
          fill="#F29559"
          d="M324.18 23.36S251.45-2.51 180.05 38.67 72.62 161.59 41.69 227.06 28.56 359.14 83.06 389.51s91.56-14.4 168-16.58 97 8.75 160.47-34.44 74.92-145.2 24.87-220.68-112.22-94.45-112.22-94.45z"
        ></path>
        <path
          fill="#fff"
          d="M324.18 23.36S251.45-2.51 180.05 38.67 72.62 161.59 41.69 227.06 28.56 359.14 83.06 389.51s91.56-14.4 168-16.58 97 8.75 160.47-34.44 74.92-145.2 24.87-220.68-112.22-94.45-112.22-94.45z"
          opacity="0.7"
        ></path>
      </g>
      <g fill="#F29559">
        <path d="M454.36 398.16c-4-.57-11.61-5.53-11.62-5.53s4.79-4 5.12-4.24c3.89-2.49 12.86-5 16.85-1.73a6.12 6.12 0 01.13 9.11c-2.59 2.56-7.07 2.88-10.48 2.39zM379.77 359.77c-.1 0 1.77-6 1.93-6.36 1.87-4.22 8-11.27 13.1-10.73a6.11 6.11 0 015.13 7.51c-.74 3.58-4.3 6.32-7.42 7.79-3.66 1.73-12.74 1.79-12.74 1.79z"></path>
        <path d="M372.3 459.83c-1.77 2.2-3.38 4.27-4.82 6.17h-3.64c1.83-2.35 4-5 6.38-7.88 1.4-1.68 2.93-3.44 4.52-5.24a59.67 59.67 0 01-4-5.55c-3.25 1.09-9.89.8-10.75.76A270.801 270.801 0 00358.5 466h-3c.24-3.4.59-7.44 1.11-12 .25-2.18.55-4.49.89-6.87-.84-.25-7.65-2.38-10.15-4.59-2.27-2-4.6-5.2-4.35-8.4a5.38 5.38 0 016.18-5.08c4.47.81 7.87 8.26 8.41 12.28 0 .24.09 2.85.1 4.5.14-1 .27-1.91.42-2.91.3-2 .66-3.93 1-6 .22-1 .44-2 .66-3.07s.54-2.09.81-3.15c.67-2.43 1.47-4.87 2.33-7.31-1.73-.26-7.85-1.3-10.41-2.95s-5.33-4.44-5.57-7.64a5.39 5.39 0 015.34-6c4.54.12 9 7 10.18 10.87.07.24.57 3.12.82 4.71.53-1.46 1.05-2.92 1.63-4.38 1.68-4.21 3.51-8.43 5.32-12.64.55-1.29 1.09-2.59 1.63-3.88-.61-.09-7.91-1.16-10.78-3-2.54-1.64-5.33-4.44-5.57-7.64a5.39 5.39 0 015.34-6c4.54.12 9 7 10.17 10.87.09.29.81 4.44.94 5.51 1.2-2.85 2.36-5.7 3.39-8.55a95.17 95.17 0 003.49-11.77c-.29 0-7.91-1.13-10.85-3-2.54-1.64-5.33-4.44-5.57-7.64a5.38 5.38 0 015.34-6c4.54.12 9 7 10.17 10.86.08.26.63 3.42.86 4.93h.26a69.09 69.09 0 001.31-12.28c.07-2.27 0-4.44-.1-6.55-1.44-.06-8-.39-10.85-1.81s-5.79-3.82-6.38-7a5.39 5.39 0 014.66-6.51c4.52-.38 9.74 5.94 11.3 9.68.09.21.72 2.37 1.16 4-.06-1-.11-1.94-.19-2.85-.29-3.43-.76-6.54-1.2-9.3-.26-1.57-.53-3-.8-4.29-1.38-.8-6.92-4.06-8.75-6.57s-3.37-6.07-2.44-9.14a5.38 5.38 0 017.13-3.63c4.19 1.75 5.91 9.76 5.57 13.8 0 .35-1.12 5.76-1.19 5.72l-.08-.05c.28 1.26.57 2.62.85 4.11.5 2.75 1 5.87 1.41 9.3a96.06 96.06 0 01.64 11.12 70.85 70.85 0 01-1 12.42v.14c.62-1.17 2.47-4.41 2.64-4.64 2.39-3.27 8.95-8.19 13.26-6.76a5.37 5.37 0 013 7.41c-1.31 2.93-4.89 4.62-7.84 5.3-3.33.77-10.59-.71-11.17-.83a95.7 95.7 0 01-3.32 12.25 173.5 173.5 0 01-2.56 7c.57-1 1.08-1.89 1.17-2 2.39-3.27 8.94-8.19 13.26-6.76a5.37 5.37 0 013 7.41c-1.31 2.93-4.88 4.62-7.83 5.3s-9.21-.45-10.85-.77c-.36.89-.7 1.78-1.06 2.67-1.72 4.26-3.45 8.5-5 12.71-.55 1.48-1 3-1.54 4.45.51-.89.94-1.64 1-1.74 2.39-3.28 8.94-8.19 13.26-6.77a5.38 5.38 0 013 7.42c-1.31 2.93-4.88 4.62-7.83 5.29s-8.61-.33-10.56-.71c-.46 1.54-.93 3.07-1.31 4.58-.23 1-.53 2-.71 3.06s-.4 2.06-.6 3.08c-.3 2-.63 4-.88 5.94-.19 1.34-.34 2.62-.49 3.91.53-1.48 1.64-4.36 1.76-4.59a20.88 20.88 0 017.35-7.55 5.93 5.93 0 01.64-1 5.37 5.37 0 017.95-.83c3.29 3.14 2 11.23.24 14.88-.1.22-1.49 2.43-2.4 3.81.66-.73 1.28-1.45 2-2.19 1.34-1.48 2.71-2.92 4.19-4.47l2.25-2.19c.73-.75 1.6-1.45 2.4-2.18 1.91-1.67 3.92-3.26 6-4.82-1.29-1.17-5.82-5.41-7-8.2s-2-6.64-.43-9.44a5.38 5.38 0 017.74-2c3.72 2.61 3.69 10.8 2.49 14.68-.07.24-1.24 2.92-1.91 4.38 1.24-.92 2.48-1.85 3.77-2.75 3.73-2.59 7.58-5.1 11.42-7.61l3.5-2.33c-.47-.42-6-5.34-7.33-8.46-1.22-2.77-2-6.65-.43-9.45a5.37 5.37 0 017.74-2c3.72 2.6 3.69 10.8 2.49 14.67-.09.29-1.78 4.16-2.26 5.12 2.57-1.72 5.11-3.45 7.54-5.26a93.76 93.76 0 009.41-7.9c-.22-.19-6-5.3-7.38-8.5-1.22-2.77-2-6.65-.44-9.44a5.37 5.37 0 017.74-2c3.73 2.61 3.69 10.8 2.5 14.67-.08.26-1.37 3.2-2 4.59a1.59 1.59 0 01.21.15 68.46 68.46 0 007.87-9.52c1.31-1.86 2.46-3.7 3.53-5.52-1.17-.85-6.47-4.75-8.05-7.49s-2.72-6.39-1.47-9.34a5.37 5.37 0 017.47-2.87c4 2.18 4.85 10.33 4.09 14.31 0 .22-.71 2.38-1.21 3.94.47-.83 1-1.68 1.41-2.48 1.65-3 3-5.87 4.13-8.42.64-1.45 1.2-2.77 1.7-4-.72-1.42-3.53-7.21-3.67-10.31s.53-6.92 3-9a5.37 5.37 0 017.95.9c2.53 3.77-.45 11.4-3 14.58-.21.28-4.1 4.19-4.14 4.12l-.05-.09c-.46 1.21-1 2.5-1.55 3.9-1.1 2.57-2.37 5.47-4 8.53a93.42 93.42 0 01-5.6 9.63 69.44 69.44 0 01-7.73 9.78.94.94 0 01-.1.1c1.16-.64 4.49-2.31 4.76-2.41 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.6 7.84c-2.7 1.72-6.61 1.15-9.45.09-3.2-1.2-8.44-6.43-8.86-6.85a94.35 94.35 0 01-9.53 8.38c-2 1.52-4 3-6 4.43 1-.52 1.95-1 2.09-1 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.6 7.84c-2.7 1.72-6.61 1.16-9.45.1s-7.44-5.46-8.63-6.63c-.78.54-1.56 1.1-2.35 1.64-3.78 2.6-7.57 5.18-11.21 7.83-1.28.93-2.5 1.9-3.74 2.86.92-.47 1.69-.85 1.81-.89 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.59 7.84c-2.71 1.72-6.62 1.16-9.46.09s-7-5-8.41-6.41c-1.23 1-2.47 2-3.61 3.09-.77.73-1.56 1.38-2.29 2.16l-2.2 2.24c-1.34 1.48-2.73 3-4 4.46-.89 1-1.73 2-2.57 3 1.27-.94 3.78-2.73 4-2.86 3.55-2 11.55-3.69 14.87-.59a5.38 5.38 0 01-.38 8C392.91 461 389 461 386 460.42c-3.26-.68-9-4.87-9.74-5.39-1.39 1.64-2.73 3.25-3.96 4.8zM328.36 398.16c-4-.57-11.61-5.53-11.62-5.53s4.79-4 5.12-4.24c3.89-2.49 12.86-5 16.85-1.73a6.12 6.12 0 01.13 9.11c-2.59 2.56-7.07 2.88-10.48 2.39zM253.77 359.77c-.1 0 1.77-6 1.93-6.36 1.87-4.22 8-11.27 13.1-10.73a6.11 6.11 0 015.13 7.51c-.74 3.58-4.3 6.32-7.42 7.79-3.66 1.73-12.74 1.79-12.74 1.79z"></path>
        <path d="M246.3 459.83c-1.77 2.2-3.38 4.27-4.82 6.17h-3.64c1.83-2.35 4-5 6.38-7.88 1.4-1.68 2.93-3.44 4.52-5.24a59.67 59.67 0 01-4-5.55c-3.25 1.09-9.89.8-10.75.76A270.801 270.801 0 00232.5 466h-2.95c.24-3.4.59-7.44 1.11-12 .25-2.18.55-4.49.89-6.87-.84-.25-7.65-2.38-10.15-4.59-2.27-2-4.6-5.2-4.35-8.4a5.38 5.38 0 016.18-5.08c4.47.81 7.87 8.26 8.41 12.28 0 .24.09 2.85.1 4.5.14-1 .27-1.91.42-2.91.3-2 .66-3.93 1-6 .22-1 .44-2 .66-3.07s.54-2.09.81-3.15c.67-2.43 1.47-4.87 2.33-7.31-1.73-.26-7.85-1.3-10.41-2.95s-5.33-4.44-5.57-7.64a5.39 5.39 0 015.34-6c4.54.12 9 7 10.18 10.87.07.24.57 3.12.82 4.71.53-1.46 1-2.92 1.63-4.38 1.68-4.21 3.51-8.43 5.32-12.64.55-1.29 1.09-2.59 1.63-3.88-.61-.09-7.91-1.16-10.78-3-2.54-1.64-5.33-4.44-5.57-7.64a5.39 5.39 0 015.34-6c4.54.12 9 7 10.17 10.87.09.29.81 4.44.94 5.51 1.2-2.85 2.36-5.7 3.39-8.55a95.17 95.17 0 003.49-11.77c-.29 0-7.91-1.13-10.85-3-2.54-1.64-5.33-4.44-5.57-7.64a5.38 5.38 0 015.34-6c4.54.12 9 7 10.17 10.86.08.26.63 3.42.86 4.93h.26a69.09 69.09 0 001.31-12.28c.07-2.27 0-4.44-.1-6.55-1.44-.06-8-.39-10.85-1.81s-5.79-3.82-6.38-7a5.39 5.39 0 014.65-6.51c4.53-.38 9.75 5.94 11.31 9.68.09.21.72 2.37 1.16 4-.06-1-.11-1.94-.19-2.85-.29-3.43-.76-6.54-1.2-9.3-.26-1.57-.53-3-.8-4.29-1.38-.8-6.92-4.06-8.75-6.57s-3.37-6.07-2.44-9.14a5.38 5.38 0 017.13-3.63c4.19 1.75 5.91 9.76 5.57 13.8 0 .35-1.12 5.76-1.19 5.72l-.08-.05c.28 1.26.57 2.62.85 4.11.5 2.75 1.05 5.87 1.41 9.3a96.06 96.06 0 01.64 11.12 70.85 70.85 0 01-1.05 12.42v.14c.62-1.17 2.47-4.41 2.64-4.64 2.39-3.27 8.95-8.19 13.26-6.76a5.37 5.37 0 013 7.41c-1.31 2.93-4.89 4.62-7.84 5.3-3.33.77-10.59-.71-11.17-.83a95.7 95.7 0 01-3.32 12.25 173.5 173.5 0 01-2.56 7c.57-1 1.08-1.89 1.17-2 2.39-3.27 8.94-8.19 13.26-6.76a5.37 5.37 0 013 7.41c-1.31 2.93-4.88 4.62-7.83 5.3s-9.21-.45-10.85-.77c-.36.89-.7 1.78-1.06 2.67-1.72 4.26-3.45 8.5-5 12.71-.55 1.48-1 3-1.54 4.45.51-.89.94-1.64 1-1.74 2.39-3.28 8.94-8.19 13.26-6.77a5.38 5.38 0 013 7.42c-1.31 2.93-4.88 4.62-7.83 5.29s-8.61-.33-10.56-.71c-.46 1.54-.93 3.07-1.31 4.58-.23 1-.53 2-.71 3.06s-.4 2.06-.6 3.08c-.3 2-.63 4-.88 5.94-.19 1.34-.34 2.62-.49 3.91.53-1.48 1.64-4.36 1.76-4.59a20.88 20.88 0 017.35-7.55 5.93 5.93 0 01.64-1 5.37 5.37 0 018-.83c3.29 3.14 2 11.23.24 14.88-.1.22-1.49 2.43-2.4 3.81.66-.73 1.28-1.45 2-2.19 1.34-1.48 2.71-2.92 4.19-4.47l2.25-2.19c.73-.75 1.6-1.45 2.4-2.18 1.91-1.67 3.92-3.26 6-4.82-1.29-1.17-5.82-5.41-7-8.2s-2-6.64-.43-9.44a5.38 5.38 0 017.74-2c3.72 2.61 3.69 10.8 2.49 14.68-.07.24-1.24 2.92-1.91 4.38 1.24-.92 2.48-1.85 3.77-2.75 3.73-2.59 7.58-5.1 11.42-7.61l3.5-2.33c-.47-.42-6-5.34-7.33-8.46-1.22-2.77-2-6.65-.43-9.45a5.37 5.37 0 017.74-2c3.72 2.6 3.69 10.8 2.49 14.67-.09.29-1.78 4.16-2.26 5.12 2.57-1.72 5.11-3.45 7.54-5.26a93.76 93.76 0 009.41-7.9c-.22-.19-6-5.3-7.38-8.5-1.22-2.77-2-6.65-.44-9.44a5.37 5.37 0 017.74-2c3.73 2.61 3.69 10.8 2.5 14.67-.08.26-1.37 3.2-2 4.59a1.59 1.59 0 01.21.15 68.46 68.46 0 007.87-9.52c1.31-1.86 2.46-3.7 3.53-5.52-1.17-.85-6.47-4.75-8.05-7.49s-2.72-6.39-1.47-9.34a5.37 5.37 0 017.47-2.87c4 2.18 4.85 10.33 4.09 14.31 0 .22-.71 2.38-1.21 3.94.47-.83 1-1.68 1.41-2.48 1.65-3 3-5.87 4.13-8.42.64-1.45 1.2-2.77 1.7-4-.72-1.42-3.53-7.21-3.67-10.31s.53-6.92 3-9a5.37 5.37 0 017.95.9c2.53 3.77-.45 11.4-3 14.58-.21.28-4.1 4.19-4.14 4.12l-.05-.09c-.46 1.21-1 2.5-1.55 3.9-1.1 2.57-2.37 5.47-4 8.53a93.42 93.42 0 01-5.6 9.63 69.44 69.44 0 01-7.73 9.78.94.94 0 01-.1.1c1.16-.64 4.49-2.31 4.76-2.41 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.6 7.84c-2.7 1.72-6.61 1.15-9.45.09-3.2-1.2-8.44-6.43-8.86-6.85a94.35 94.35 0 01-9.53 8.38c-2 1.52-4 3-6 4.43 1-.52 1.95-1 2.09-1 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.6 7.84c-2.7 1.72-6.61 1.16-9.45.1s-7.44-5.46-8.63-6.63c-.78.54-1.56 1.1-2.35 1.64-3.78 2.6-7.57 5.18-11.21 7.83-1.28.93-2.5 1.9-3.74 2.86.92-.47 1.69-.85 1.81-.89 3.8-1.41 12-1.9 14.79 1.67a5.37 5.37 0 01-1.59 7.84c-2.71 1.72-6.62 1.16-9.46.09s-7-5-8.41-6.41c-1.23 1-2.47 2-3.61 3.09-.77.73-1.56 1.38-2.29 2.16l-2.2 2.24c-1.34 1.48-2.73 3-4 4.46-.89 1-1.73 2-2.57 3 1.27-.94 3.78-2.73 4-2.86 3.55-2 11.55-3.69 14.87-.59a5.38 5.38 0 01-.38 8C266.91 461 263 461 260 460.42c-3.26-.68-9-4.87-9.74-5.39-1.39 1.64-2.73 3.25-3.96 4.8zM48.33 405.73c3.56-.51 10.32-4.92 10.32-4.92s-4.25-3.57-4.55-3.76c-3.45-2.21-11.42-4.46-15-1.54a5.44 5.44 0 00-.1 8.09c2.32 2.28 6.3 2.57 9.33 2.13zM114.61 371.62c.08 0-1.58-5.33-1.72-5.65-1.66-3.75-7.07-10-11.64-9.54a5.43 5.43 0 00-4.56 6.68c.66 3.17 3.83 5.61 6.6 6.92 3.25 1.53 11.31 1.59 11.32 1.59z"></path>
        <path d="M121.24 460.52c1.57 2 3 3.79 4.28 5.48h3.24a252.56 252.56 0 00-9.67-11.65 53.18 53.18 0 003.59-4.94c2.88 1 8.78.71 9.55.67.22 1.9.41 3.75.57 5.5.37 3.95.6 7.46.75 10.42h2.62c-.21-3-.52-6.61-1-10.66-.22-1.93-.49-4-.78-6.1.74-.23 6.79-2.12 9-4.08 2-1.79 4.09-4.62 3.87-7.46a4.79 4.79 0 00-5.49-4.52c-4 .72-7 7.34-7.48 10.91 0 .21-.08 2.53-.08 4-.13-.86-.24-1.7-.38-2.59-.27-1.75-.59-3.49-.92-5.36-.2-.9-.39-1.81-.59-2.73s-.48-1.86-.72-2.8c-.59-2.16-1.3-4.33-2.07-6.49 1.54-.24 7-1.16 9.24-2.63s4.74-3.94 5-6.78a4.79 4.79 0 00-4.75-5.3c-4 .11-8 6.2-9 9.65-.06.22-.51 2.78-.73 4.2-.47-1.3-.93-2.6-1.45-3.9-1.49-3.74-3.12-7.49-4.72-11.23-.5-1.15-1-2.3-1.46-3.44.55-.08 7-1 9.58-2.68 2.26-1.46 4.74-3.94 5-6.79a4.77 4.77 0 00-4.74-5.29c-4 .11-8 6.19-9 9.65-.08.26-.72 3.95-.83 4.9-1.07-2.53-2.1-5.06-3-7.59a84.77 84.77 0 01-3.09-10.46c.25 0 7-1 9.63-2.69 2.26-1.46 4.74-3.94 5-6.79a4.77 4.77 0 00-4.74-5.29c-4 .11-8 6.19-9 9.65-.07.23-.56 3-.76 4.38h-.23a61.88 61.88 0 01-1.48-10.9c-.06-2 0-4 .09-5.83 1.28 0 7.13-.34 9.64-1.6s5.15-3.4 5.67-6.2a4.78 4.78 0 00-4.13-5.78c-4-.34-8.66 5.27-10 8.6-.07.18-.64 2.1-1 3.51.06-.85.1-1.72.17-2.53.25-3 .67-5.81 1.07-8.26.23-1.39.47-2.65.71-3.82 1.23-.7 6.15-3.6 7.77-5.83s3-5.39 2.17-8.12a4.78 4.78 0 00-6.33-3.23c-3.73 1.56-5.26 8.67-5 12.26 0 .31 1 5.12 1 5.09l.17-.05c-.25 1.12-.51 2.33-.76 3.65-.45 2.45-.93 5.22-1.25 8.26a84.62 84.62 0 00-.57 9.89 62.53 62.53 0 00.93 11v.13c-.55-1-2.19-3.92-2.34-4.13-2.13-2.9-8-7.27-11.78-6a4.78 4.78 0 00-2.66 6.59c1.16 2.61 4.33 4.1 7 4.71 3 .68 9.41-.63 9.92-.74a84 84 0 003 10.89c.7 2.08 1.47 4.15 2.27 6.21-.51-.88-1-1.68-1-1.78-2.13-2.91-7.95-7.28-11.78-6a4.78 4.78 0 00-2.66 6.59c1.16 2.6 4.33 4.1 7 4.7s8.18-.39 9.64-.68c.31.79.62 1.59.94 2.37 1.53 3.79 3.07 7.55 4.46 11.3.5 1.31.93 2.63 1.38 3.95-.45-.79-.84-1.45-.91-1.55-2.13-2.91-8-7.28-11.78-6a4.78 4.78 0 00-2.66 6.59c1.16 2.6 4.34 4.1 7 4.71s7.64-.3 9.38-.63c.41 1.36.83 2.72 1.16 4.06.21.91.48 1.78.64 2.72s.35 1.83.53 2.74c.27 1.75.56 3.55.78 5.27.17 1.19.3 2.33.44 3.48-.48-1.32-1.46-3.88-1.57-4.08a18.39 18.39 0 00-6.53-6.71 5.21 5.21 0 00-.56-.9 4.78 4.78 0 00-7.07-.73c-2.92 2.79-1.79 10-.22 13.22.1.19 1.33 2.15 2.14 3.38l-1.75-2c-1.19-1.31-2.41-2.59-3.73-4l-2-1.94c-.65-.67-1.42-1.29-2.14-1.94-1.69-1.48-3.48-2.89-5.31-4.28 1.15-1 5.17-4.81 6.26-7.28s1.78-5.91.39-8.4a4.79 4.79 0 00-6.88-1.8c-3.31 2.32-3.28 9.6-2.22 13 .07.22 1.11 2.6 1.71 3.9-1.11-.82-2.21-1.65-3.36-2.45-3.31-2.3-6.73-4.52-10.14-6.76-1-.68-2.07-1.38-3.11-2.07.41-.37 5.3-4.74 6.51-7.51 1.08-2.47 1.78-5.91.39-8.4a4.79 4.79 0 00-6.88-1.8c-3.3 2.32-3.28 9.6-2.21 13 .08.26 1.58 3.69 2 4.54-2.28-1.52-4.53-3.06-6.7-4.67a83.6 83.6 0 01-8.35-7c.19-.17 5.31-4.71 6.55-7.56 1.09-2.46 1.78-5.9.39-8.39a4.78 4.78 0 00-6.88-1.8c-3.3 2.32-3.28 9.6-2.21 13 .07.23 1.21 2.84 1.78 4.07a2.14 2.14 0 01-.19.13 61.38 61.38 0 01-7-8.45c-1.16-1.65-2.18-3.29-3.14-4.91 1-.75 5.75-4.22 7.16-6.65s2.41-5.68 1.3-8.3a4.76 4.76 0 00-6.63-2.54c-3.54 1.93-4.32 9.17-3.64 12.71 0 .19.63 2.11 1.08 3.5-.42-.74-.87-1.49-1.26-2.21-1.46-2.67-2.64-5.21-3.66-7.47-.58-1.29-1.07-2.47-1.52-3.58.64-1.26 3.14-6.4 3.27-9.16s-.48-6.14-2.67-8a4.77 4.77 0 00-7.06.8c-2.25 3.35.4 10.13 2.63 13 .2.24 3.65 3.72 3.69 3.65v-.07c.41 1.07.87 2.22 1.39 3.46 1 2.29 2.1 4.86 3.51 7.58a85.22 85.22 0 005 8.56 61.53 61.53 0 006.86 8.68l.1.1c-1-.57-4-2.06-4.23-2.15-3.38-1.26-10.64-1.69-13.14 1.48a4.78 4.78 0 001.41 7c2.41 1.53 5.88 1 8.4.08 2.85-1.06 7.5-5.71 7.87-6.09a82.72 82.72 0 008.48 7.45c1.73 1.35 3.51 2.65 5.32 3.93-.91-.46-1.73-.87-1.85-.91-3.38-1.25-10.65-1.69-13.14 1.49a4.77 4.77 0 001.41 7c2.41 1.53 5.88 1 8.4.08s6.61-4.84 7.67-5.88l2.09 1.46c3.36 2.31 6.72 4.6 10 6.95 1.14.83 2.23 1.69 3.33 2.54-.81-.41-1.5-.75-1.61-.79-3.38-1.25-10.64-1.69-13.14 1.49a4.77 4.77 0 001.42 7c2.4 1.53 5.88 1 8.4.08s6.21-4.46 7.47-5.7c1.1.91 2.19 1.82 3.21 2.75.69.65 1.39 1.23 2 1.92l2 2c1.19 1.31 2.43 2.66 3.56 4 .8.9 1.54 1.78 2.28 2.66-1.12-.84-3.36-2.43-3.56-2.54-3.15-1.75-10.26-3.28-13.21-.52a4.78 4.78 0 00.34 7.1c2.15 1.87 5.66 1.9 8.29 1.35 2.9-.61 8-4.32 8.66-4.79 1.03 1.5 2.18 2.93 3.27 4.31z"></path>
      </g>
      <g>
        <rect
          width="200.26"
          height="378.27"
          x="156.87"
          y="50.04"
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          rx="7.67"
        ></rect>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M165.78 91.57H348.24V386.77H165.78z"
        ></path>
        <path
          fill="#fff"
          d="M276.84 70.91h-39.67a2.7 2.7 0 01-2.7-2.7 2.7 2.7 0 012.7-2.71h39.67a2.7 2.7 0 012.7 2.71 2.7 2.7 0 01-2.7 2.7z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.704"
          d="M267.82 403.44A10.82 10.82 0 10257 414.26a10.81 10.81 0 0010.82-10.82z"
        ></path>
        <path fill="#263238" d="M251.52 397.95H262.49V408.92H251.52z"></path>
      </g>
      <g stroke="#263238">
        <path
          fill="#d9d9d9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M361.78 274.83l-1.18 9s-4.88 33.43-1.5 50.71 9.76 34.93 10.14 39.06-1.88 20.28.75 33.43 7.51 39.06 7.51 39.06l-4.13 9.77s-8.64 5.63-9.76 7.51a1.69 1.69 0 00.75 2.63h27a15.36 15.36 0 001.13-6.39v-26.29c0-2.63 1.5-47.32 3-55.21s3-67.61 3-67.61H400s7.14 59.34 9 65.73 9.77 33.8 12 39.44 4.89 25.16 6.39 30.05a101.1 101.1 0 013.38 13.52 33 33 0 001.88 6.76H453s.38-3.38-1.13-5.63-11.26-12-12.77-19.16 2.26-40.21 1.9-51.83-3.76-13.15-3.76-23.29S441 325.15 441 310.5s-2-28.15-5.67-35.86l-5.22-5.08h-64.63z"
        ></path>
        <path
          fill="#F29559"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M442.15 447.92v.05s-5.26-3.38-7.14-.75-1.88 4.13-1.88 4.13h-4a67.18 67.18 0 011.75 7.89 33 33 0 001.88 6.76H453s.38-3.38-1.13-5.63c-1.06-1.6-6.23-6.94-9.72-12.45z"
        ></path>
        <path
          fill="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M432.72 466H453a11.72 11.72 0 00-.07-2.61h-21.12c.46 1.5.91 2.61.91 2.61z"
        ></path>
        <path
          fill="#F29559"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M392.53 459.61v-6.38h-7.14s.38-3-3-5.26-6.77 3-6.77 3h-.18l-2.07 4.88s-8.64 5.63-9.76 7.51a1.69 1.69 0 00.75 2.63h27a15.36 15.36 0 001.17-6.38z"
        ></path>
        <path
          fill="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M363.59 463.39a1.69 1.69 0 00.77 2.61h27a11.07 11.07 0 00.78-2.61zM439 427.36c.63-12.79 2.23-30.18 2-38-.37-11.65-3.76-13.15-3.76-23.29S441 325.15 441 310.5s-2-28.15-5.67-35.86l-5.22-5.08h-64.63l-3.7 5.27-1.18 9s-4.88 33.43-1.5 50.71 9.76 34.93 10.14 39.06-1.88 20.28.75 33.43c1.16 5.77 2.74 14 4.16 21.42a70 70 0 0018.46 1.67c.32-10.87 1.62-45.19 2.92-52 1.5-7.89 3-67.61 3-67.61H400s7.14 59.34 9 65.73 9.77 33.8 12 39.44c1 2.4 2 7.32 3 12.56a32.47 32.47 0 0015-.88z"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M404.55 307.12L424.83 290.97"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M374.87 292.47L385.39 301.11"
        ></path>
        <path
          fill="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M419 110.46s-8.63-5.1-8.43-2.35 3.92 4.7 3.92 4.7-12.36-1.76-14.32-1 1.38 1.77 1.38 1.77-15.3 11.76-20.59 19.8-10 19.81-4.51 28.83 13.53 16.08 27.06 20 26.86-.2 35.88-3.92 18-14.32 16.47-27.65-13.37-27.24-22.2-36.64-14.31-8-14.31-6.67a17.75 17.75 0 01-.35 3.13z"
        ></path>
        <path
          fill="#d9d9d9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M397.84 166.16l-2 15.09s-14.32 4.7-19.61 6.86-7.65 4.9-8.63 7.25-15 35-15.6 38.1.39 4.51 4.7 6.47 16.3-5.29 16.3-5.29l1.57 5.49s-7.85 13.33-9.22 17.64-3.53 17.06-3.53 17.06 14.9 7.45 38.43 6.87 35.1-7.06 35.1-7.06-2.55-12.75-5.29-20.2-5.1-10.39-5.1-13.33 8.63-18.24 8.63-18.24l18.22 8.59s-4.3-14.86-5.48-24.86-3.21-11.63-7.14-15.16-21.17-8.62-21.76-9 .78-16.86.78-16.86-14.88 3.92-20.37.58z"
        ></path>
        <path
          fill="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M409.22 176.49c2.74-1 6-3.59 8.56-5.91.21-2.81.39-5 .39-5s-14.84 3.94-20.33.6l-1.35 10c3.04 2.72 8 2.09 12.73.31z"
        ></path>
        <path
          fill="#F29559"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M430 254.44c-2.75-7.45-5.1-10.39-5.1-13.33s8.63-18.24 8.63-18.24l18.22 8.59s-4.3-14.86-5.48-24.86c-.63-5.41-1.53-8.36-2.83-10.5-27.94 3.55-59-2.82-71.39-5.83a11.69 11.69 0 00-4.49 5.09c-1 2.36-15 35-15.6 38.1s.39 4.51 4.7 6.47 16.34-5.29 16.34-5.29l1.57 5.49s-7.85 13.33-9.22 17.64-3.53 17.06-3.53 17.06 14.9 7.45 38.43 6.87 35.1-7.06 35.1-7.06-2.59-12.75-5.35-20.2z"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M375.48 229.24s-3.9-8.17-2.84-12.43 1.78-5.33 1.78-5.33"
        ></path>
        <path
          fill="#F29559"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M446.29 206.6c-.63-5.41-1.53-8.36-2.83-10.5-27.94 3.55-59-2.82-71.39-5.83a11.69 11.69 0 00-4.49 5.09c-.34.83-2.31 5.42-4.73 11.14 11 3 53.13 13.43 84.87 8.54-.6-2.91-1.12-5.84-1.43-8.44z"
        ></path>
        <path
          fill="#d9d9d9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M401.67 129.7l25 16.11-.69 6.51s4.46-4.45 5.15.35-1 7.2-4.12 8.57-4.8 1-4.8 1-7.54 8.22-13 10.28-11.3 2.6-14-1.86-6.54-12.54-5.51-17.34S400 129.7 400 129.7z"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M404.13 144.93a5.35 5.35 0 01-1.18 3.33c-1.17 1.18-3.92 2.75-3.92 3.92s2.55 3.53 4.9 3.34M399.81 158.07a6.72 6.72 0 007.85-.2M409.23 147.87s4.31-1.57 6.66 1.76M395.89 145.91s3.53-1.57 5.3.39M398.05 139.24a5 5 0 015.49-1.57M411.19 139.63s5.49.2 6.66 5.3"
        ></path>
        <path
          fill="#d9d9d9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M361 227s-6.08 2.35-8 6.08-1.57 12.35 6.07 14.51 64.12-9.22 64.12-9.22a64.86 64.86 0 004.51 6.08c1.38 1.37 4.91 4.12 5.1 5.29s.59 8.63 2.16 9 1-3.53 1-3.53 2.55-3.72 2.55-5.49.39-7.45 0-8.82-9.61-9.41-11.57-10-52.16-2-56.86-2.75-7.52-1.36-9.08-1.15z"
        ></path>
        <rect
          width="11.83"
          height="26.49"
          x="415.39"
          y="150.74"
          fill="#F29559"
          strokeMiterlimit="10"
          rx="2.31"
          transform="rotate(-146.39 421.304 163.994)"
        ></rect>
        <path
          fill="#d9d9d9"
          strokeMiterlimit="10"
          d="M429 173.35s1.24-3.18 2.47-5.47 1.24-3.36.36-3.36a4.88 4.88 0 00-3.89 3.71 18.34 18.34 0 00-.35 5.83z"
        ></path>
        <path
          fill="#d9d9d9"
          strokeMiterlimit="10"
          d="M418.39 185.54s10.07-10.07 10.42-10.95 0-12.35-.15-15.59a1 1 0 00-.85-1h0a1 1 0 00-1.21.93l-.79 9.29-2.31-11.7a1 1 0 00-1-.84h0a1 1 0 00-1 1.09l.65 13-2.9-11.13a1.08 1.08 0 00-1.33-.77h0a1.08 1.08 0 00-.79 1.16l1.31 12-2.47 2.12v-4.24l-3-5a.84.84 0 00-1.09-.32h0a.83.83 0 00-.39 1.09l2 4.39s-3.89 15.9-4.07 16.43.71 3.36 1.24 4.42 24.2 51.22 25.61 53.16 10.95 4.95 15.19.35 2.83-9.18.53-14.48-33.6-43.41-33.6-43.41z"
        ></path>
      </g>
      <g>
        <circle cx="254" cy="149" r="42" fill="#F29559"></circle>
        <a href="mailto:cbaiorte@gmail.com?subject=Hi! I looked your portfolio and I think we can make history together!" className="container-email icon-pulse">
          <path
            fill="#263238"
            d="M279.64 129.99L229.86 129.99 254.4 153.65 279.64 129.99z"
          ></path>
          <path
            fill="#263238"
            d="M264.37 148.41L281.7 163.73 281.7 132.17 264.37 148.41z"
          ></path>
          <path
            fill="#263238"
            d="M244.62 148.38L227.06 131.46 227.06 163.01 244.62 148.38z"
          ></path>
          <path
            fill="#263238"
            d="M262.17 150.47L254.37 157.78 246.79 150.48 228.52 165.7 279.4 165.7 262.17 150.47z"
          ></path>
        </a>
        <circle cx="254" cy="241" r="42" fill="#F29559"></circle>
        <a href="tel:+351912992834" className="container-phone icon-pulse">
          <path
            fill="#263238"
            d="M248.39 227.75a1.86 1.86 0 002.67.71c1.37-.75 2.74-1.5 4-2.37a5.34 5.34 0 001.1-1.49c-.25-.59-.38-1-.58-1.36-.54-1-1.12-2-1.69-3l-5.79-10a2 2 0 00-3.11-.83c-1.24.7-2.47 1.4-3.68 2.14a1.83 1.83 0 00-.75 2.64q3.9 6.81 7.83 13.56zM277.22 260.66q-3.8-6.6-7.62-13.18a1.89 1.89 0 00-2.87-.81q-1.91 1.07-3.78 2.19a1.88 1.88 0 00-.83 2.64l8.28 14.13a1.85 1.85 0 002.19.17c1.34-.73 2.69-1.46 4-2.31a6.24 6.24 0 001.18-1.45 9.66 9.66 0 00-.55-1.38zM260.08 252.41a6 6 0 01-5-.44 12.62 12.62 0 01-2.38-1.58 23.57 23.57 0 01-7.39-12.39c-.73-3-.93-6 1.37-8.4l-8.52-14.6c-.67.43-1.32.84-1.93 1.27a7.94 7.94 0 00-3.73 7.34 47.41 47.41 0 001.29 8.81 69.76 69.76 0 0014.71 27.08 36.76 36.76 0 009 7.91 9.77 9.77 0 0011.08-.51z"
          ></path>
        </a>
        <circle cx="254" cy="333" r="42" fill="#F29559"></circle>
        <a href="sms://+351912992834?body=Hi! I looked your portfolio and I think we can make history together!" className="container-message icon-pulse">
          <path
            fill="#263238"
            d="M247.81 340.87h-9.33v4.73a5.82 5.82 0 005.41 5.81zM273.82 324.67h-4v8.23a8 8 0 01-8 8h-.14l-14.28 10.53h15.5l-3.83 10.3 13.93-10.3h.84a5.84 5.84 0 005.84-5.83v-15.1a5.84 5.84 0 00-5.86-5.83z"
          ></path>
          <path
            fill="#263238"
            d="M261.81 312H232.3a5.83 5.83 0 00-5.83 5.83v15.1a5.84 5.84 0 005.83 5.84h18.59L247.06 349 261 338.74h.84a5.85 5.85 0 005.84-5.84v-15.1a5.84 5.84 0 00-5.87-5.8z"
          ></path>
          <circle cx="238.97" cy="324.97" r="2.09" fill="#F29559"></circle>
          <path
            fill="#F29559"
            d="M249.57 325a2.09 2.09 0 11-2.09-2.09 2.1 2.1 0 012.09 2.09zM258.07 325a2.09 2.09 0 11-2.08-2.09 2.09 2.09 0 012.08 2.09z"
          ></path>
        </a>
      </g>
      <g>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M153.17 210.61l.76-1 12.39-16.88s1.68-10.07 2.52-12.59 2.52-7.83 3.08-9.79 1.12-4.2 2.24-3.36 1.12 4.2.56 5.88a9.53 9.53 0 00-.28 4.75c.28.84 15.11-11.75 16.5-10.63s-.55 6.44-3.35 10.07-14.27 16.79-14.27 16.79-13.15 35.25-17.07 40.85-4.75 3.08-8.67 0-9-10.07-9-10.07z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M173.6 187.11s1.4-5 2.8-6.16 6.71-4.47 6.71-4.47l3.64-11.2s1.12-.84.84 1.68-.84 8.12-1.68 10.63-4.48 7-4.48 7"
        ></path>
        <path
          fill="#F29559"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M133.03 167.8L154.57 210.05 138.07 226.84 133.31 210.89 133.03 167.8z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M136.09 220.22L138.07 226.84 154.57 210.05 151.6 204.23 136.09 220.22z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M81.38 446l-2 7.93s-11.73 6.5-12.63 7.4-.55 4.69-.55 4.69h33.58a30.79 30.79 0 00-.72-8.66 95.2 95.2 0 01-.93-10.61z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M66.21 466h33.57a20.14 20.14 0 000-2.17H66.15c-.03 1.17.06 2.17.06 2.17z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M67.48 461a15.62 15.62 0 018.12-3.61c5.41-.91 10.29 1.08 11.37 2.16s1.8 4.15 1.8 4.15l-22.62.18a1.89 1.89 0 011.33-2.88zM96.35 452.37c0 1.95-.68 3.52-1.53 3.52s-1.54-1.57-1.54-3.52.69-3.52 1.54-3.52 1.53 1.58 1.53 3.52z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M165.18 446l2 7.93s11.73 6.5 12.63 7.4.54 4.69.54 4.69h-33.57a30.34 30.34 0 01.72-8.66 97 97 0 00.92-10.61z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M180.34 466h-33.56a21.47 21.47 0 01-.06-2.17h33.69a20.08 20.08 0 01-.07 2.17z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M179.08 461a15.68 15.68 0 00-8.12-3.61c-5.41-.91-10.29 1.08-11.37 2.16s-1.81 4.15-1.81 4.15l22.63.18a1.89 1.89 0 00-1.33-2.88zM150.2 452.37c0 1.95.69 3.52 1.54 3.52s1.53-1.57 1.53-3.52-.68-3.52-1.53-3.52-1.54 1.58-1.54 3.52z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M81 277.66L79.89 295.16 81.38 445.98 98.13 446.73 114.89 307.45 117.13 306.7 148.42 446.73 165.18 445.98 157.72 352.14 146.46 271.6 81 277.66z"
        ></path>
        <path
          fill="none"
          stroke="gray"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M116.36 282.41L116.36 295.18 119.84 289.38 120.43 280.67"
        ></path>
        <path
          fill="#F29559"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M92.46 165.84S54.69 182.35 54.13 184s-10.63 43.37-9 47.28a9.56 9.56 0 0012 5c5.31-2 10.35-22.38 10.35-22.38s11.75 35.81 11.75 39.45 1.12 26 1.12 26 21.54 3.07 39.45-1.12 26.58-6.72 26.58-6.72l-8.39-51.2s-4.48-50.64-5-52.6-32.46-2.52-35-2.24-5.53.37-5.53.37z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M63.81 226a26 26 0 00-6.67-10.89c-3.12-2.77-7.27-1.2-10.11.52-1.5 7.77-2.47 14.3-1.85 15.73a9.56 9.56 0 0012 5c2.43-.9 4.82-5.56 6.63-10.36z"
        ></path>
        <path
          fill="#263238"
          d="M74.87 237l63.71-13.39-.51-3.16s-.1-1-.25-2.81l-64.74 13.6c.6 1.86 1.2 3.76 1.79 5.76z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M146.46 271.6l-6.29-38.34-62.55 13a45.48 45.48 0 011.69 7.2c0 3.63 1.12 26 1.12 26s21.54 3.07 39.45-1.12 26.58-6.74 26.58-6.74zM98.06 165.56c-2.52.28-5.6.28-5.6.28s-7.08 3.1-15.16 6.75l32.7 33.76s7-33.67 6.38-36.57a30.31 30.31 0 00-1.16-4c-8.03-.29-15.96-.35-17.16-.22z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M108.69 156.05s1.68 14.55 2.52 17.35-4.76 22.38-4.76 22.38-16.23-16.51-18.19-21.26-6.43-21.27-6.43-21.27 14.27 7.28 26.86 2.8z"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M81.83 153.25s1 3.77 2.3 8.22c.68.38 1.5.81 2.5 1.31a28.68 28.68 0 0017 3.11 7.91 7.91 0 005.76-4.2c-.4-3.13-.69-5.64-.69-5.64-12.6 4.48-26.87-2.8-26.87-2.8z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M101.5 119.33s4.24 8.49 7.08 12.17 7.36 11.9 5.38 16.71-3.28 13-9.63 13.88a28.76 28.76 0 01-17-3.12c-5.1-2.55-5.66-3.4-5.66-3.4s-4.25 0-6.8-2-7.64-8.21-6.23-13.59 4.82-5.95 4.82-5.95-7.08-2.83-2.55-9.91 14.15-9.62 18.69-9.62 11.9 4.83 11.9 4.83z"
        ></path>
        <path
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M100.08 128.67a8.21 8.21 0 002.55 2.55c2 1.42 4.81.57 4 3.12s-2.83 3.39-4.53 3.11M106.88 140.57s-5.38 3.11-9.06 2.83a10.08 10.08 0 01-5.38-1.7"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M95 143.4s2 7.08 4.81 4.81a10.45 10.45 0 003.4-6A18.57 18.57 0 0195 143.4z"
        ></path>
        <path
          fill="#263238"
          d="M94.71 131.13c.62 1 .64 2.09 0 2.47s-1.6-.1-2.23-1.08-.64-2.09 0-2.48 1.6.1 2.23 1.09zM103.75 126.85c.62 1 .64 2.1 0 2.48s-1.6-.1-2.23-1.09-.64-2.09 0-2.47 1.6.1 2.23 1.08z"
        ></path>
        <path
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M88.77 130.28s.82-3.78 3.78-4.28M98.47 124.36s1.65-3.12 4.28-1.81"
        ></path>
        <path
          fill="#263238"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M74.31 128.11s18.41 0 19.83-3.12-2.84-5.38-2.84-5.38 15.86.57 17.56-4.25-5.66-6.79-7.93-6.79h-3.4s-.85-7.08-9.06-5.38-24.07 12.46-26 18.69-6.51 8.21-3.11 15.57 12.74 13.31 12.74 13.31-1.42-5.38 1.42-5.66 7.64 1.69 8.49 1.69 3.4-2.26 2-3.68-2.83-2.26-3.11-3.11 1.41-3.68.28-6.23-6.87-5.66-6.87-5.66z"
        ></path>
        <rect
          width="12.5"
          height="27.98"
          x="72.78"
          y="138.24"
          fill="#F29559"
          stroke="#263238"
          strokeMiterlimit="10"
          rx="2.31"
          transform="rotate(-33.61 79.04 152.227)"
        ></rect>
        <path
          fill="#fff"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M70.92 162.11s-1.31-3.35-2.61-5.78-1.31-3.54-.38-3.54A5.15 5.15 0 0172 156.7a19.73 19.73 0 01.37 6.16z"
        ></path>
        <path
          fill="#fff"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M82.11 175s-10.63-10.63-11-11.56.05-13 .16-16.47a1.11 1.11 0 01.9-1h0a1.1 1.1 0 011.28 1l.84 9.8 2.43-12.36a1.09 1.09 0 011.08-.88h0a1.1 1.1 0 011.09 1.15l-.69 13.77 3.07-11.75a1.13 1.13 0 011.4-.81h0a1.14 1.14 0 01.83 1.11l-1.39 12.65 2.61 2.24v-4.48l3.13-5.26a.87.87 0 011.15-.34h0a.89.89 0 01.41 1.15l-2.08 4.64s4.11 16.78 4.29 17.34-.74 3.55-1.3 4.67-25.56 54.09-27 56.14-11.56 5.22-16 .37-3-9.7-.56-15.29S82.11 175 82.11 175z"
        ></path>
        <path
          fill="none"
          stroke="gray"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M85.84 288.46L100 296.65"
        ></path>
        <path
          fill="none"
          stroke="gray"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M143.19 282.87L134.63 294.04"
        ></path>
      </g>
      <path
        fill="none"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M30 466L477 466"
      ></path>
    </svg>
  )
}